import { InjectionToken } from '@angular/core';

export interface Messaging {
  banner: string;
  launcher: string;
  contact_form: {
    title: string;
    submit: string;
    confirmation: string;
  };
}

export interface FreshdeskConfig {
  disabled: boolean;
  widgetId: string;
  environment: string;
  messaging?: Messaging;
}

export const FRESH_DESK_CONFIG = new InjectionToken<FreshdeskConfig>(
  'FreshdeskConfig'
);
